(function(){
  if(window.__sno3Col)return;window.__sno3Col=true;
  function refreshProgress(cart){
    var el=document.querySelector('.sno3col__prog');if(!el)return;
    var target=parseInt(el.getAttribute('data-target'),10)||0;if(!target)return;
    var count=cart&&typeof cart.item_count!=='undefined'?cart.item_count:0;
    var pct=Math.min(100,Math.round(count/target*100));
    var fill=el.querySelector('.sno3col__prog-fill');if(fill)fill.style.width=pct+'%';
    var remaining=Math.max(0,target-count);var txt=el.querySelector('.sno3col__prog-text');
    if(txt){ if(remaining<=0){ txt.textContent=el.getAttribute('data-done'); } else { txt.textContent=el.getAttribute('data-msg').replace('{n}',remaining); } }
  }
  function getCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});}
  document.addEventListener('submit',function(e){
    var form=e.target&&e.target.closest?e.target.closest('.sno3col__form'):null;if(!form)return;
    e.preventDefault();var btn=form.querySelector('button');var orig=btn?btn.textContent:'Add +';
    if(btn){btn.disabled=true;btn.textContent='Adding…';}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.json();})
      .then(function(){if(btn){btn.textContent='Added ✓';}return getCart();})
      .then(function(cart){
        if(cart&&typeof cart.item_count!=='undefined'){document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count],cart-icon .count').forEach(function(el){el.textContent=cart.item_count;});}
        refreshProgress(cart);
        setTimeout(function(){if(btn){btn.textContent=orig;btn.disabled=false;}},1500);
      })
      .catch(function(){if(btn){btn.textContent=orig;btn.disabled=false;}});
  });
  if(document.querySelector('.sno3col__prog')){getCart().then(refreshProgress).catch(function(){});}
})();

// Scent filter — real in-place filtering of the rendered grid (no page reload).
(function(){
  if(window.__sno3Scent)return;window.__sno3Scent=true;
  var row=document.querySelector('[data-scentrow]');
  var grid=document.querySelector('[data-grid]');
  if(!row||!grid)return;
  var pills=Array.prototype.slice.call(row.querySelectorAll('.sno3col__stype'));
  var cards=Array.prototype.slice.call(grid.querySelectorAll('.sno3col__card'));
  var emptyMsg=document.querySelector('[data-empty]');
  function cardScents(c){return (c.getAttribute('data-scent')||'').trim().split(/\s+/).filter(Boolean);}
  // live counts
  pills.forEach(function(p){
    var want=p.getAttribute('data-scent')||'';
    var n=want===''?cards.length:cards.filter(function(c){return cardScents(c).indexOf(want)>-1;}).length;
    var badge=p.querySelector('[data-count]');if(badge)badge.textContent=n;
    if(want!==''&&n===0)p.setAttribute('hidden','');
  });
  var present=pills.filter(function(p){var w=p.getAttribute('data-scent')||'';return w!==''&&cards.filter(function(c){return cardScents(c).indexOf(w)>-1;}).length>0;}).length;
  if(present<2){row.style.display='none';return;}
  function apply(want){
    var shown=0;
    cards.forEach(function(c){
      var ok=want===''||cardScents(c).indexOf(want)>-1;
      c.style.display=ok?'':'none';if(ok)shown++;
    });
    if(emptyMsg)emptyMsg.hidden=shown!==0;
    grid.style.display=shown===0?'none':'';
  }
  row.addEventListener('click',function(e){
    var btn=e.target&&e.target.closest?e.target.closest('.sno3col__stype'):null;if(!btn)return;
    pills.forEach(function(p){p.classList.remove('is-active');});
    btn.classList.add('is-active');
    apply(btn.getAttribute('data-scent')||'');
    var top=row.getBoundingClientRect().top;if(top<0)row.scrollIntoView({behavior:'smooth',block:'start'});
  });
})();
